import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CompanyAttachmentService {

  constructor(
    private http: HttpClient
  ) { }

  getCompanyAttachments(companyId: any, queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_ATTACHMENTS + `/company/${companyId}`, { params })
      .pipe(catchError(errorHandl));
  }

  getById(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANY_ATTACHMENTS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  save(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.COMPANY_ATTACHMENTS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.COMPANY_ATTACHMENTS, payload)
        .pipe(catchError(errorHandl));
    }
  }

  delete(id: any) {
    return this.http.delete(urls.API_URL + urls.COMPANY_ATTACHMENTS + `/${id}`)
        .pipe(catchError(errorHandl));
  }
}
